export const RestErrorStates: Record<number, string> = {
  0: 'NETWORK_ERROR',
  401: 'UNAUTHORIZED',
  403: 'FORBIDDEN',
  404: 'NOT_FOUND',
  409: 'ITEM_ALREADY_EXIST',
  500: 'INTERNAL_SERVER_ERROR'
};
